var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { AccountSubHeader } from '..';
import Typography from '@mui/material/Typography';
const TotalItem = styled((_a) => {
    var { heading, children } = _a, props = __rest(_a, ["heading", "children"]);
    return (_jsxs(Stack, Object.assign({}, props, { direction: 'row', spacing: 3 }, { children: [_jsx(AccountSubHeader, { children: heading }), _jsx(Typography, { children: children })] })));
})(({ theme }) => ({
    justifyContent: 'space-between',
}));
export default TotalItem;
